import React, { useEffect, useMemo, useRef, useState } from "react";
import * as PR from "../prime-react/index";
import { logo, logoDark, chatIcon } from "../assets/images/index";
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useDispatch,useSelector } from 'react-redux';
import { getUnreadCount, logout } from "../services/api";
import ProfileImageDisplay from "../shared/ProfileImageDisplay";
import { newsActions } from "../store/news";
import { resetAlertPlatFormFilters, resetFilter, resetReportFilter, resetUserFilters } from "../store/filter.slice";
import { ErrorMessage, useToast } from "../context/ToastContext";
import { filterOptionsActions } from "../store/FiltersOptions";

const logoutApiError = 'logout_api_error'

const Header = () => {
  const { showToast, clearError } = useToast();
  const menu = useRef(null);
  const navigate = useNavigate();
  const userMenu = useRef(null);
  const [visible, setVisible] = useState(false);
  const dispatch = useDispatch()
  const sessionData = useSelector(state => state?.auth?.sessionData);
  const profileData = useSelector(state => state?.auth?.profileData);
  const menuLinking = useSelector(state => state?.headerMenu);
  const store = useSelector((state) => state.filterOptions);
  const location = useLocation();

  const role = useSelector(state => state.auth.role);
      const headers = useMemo(() => {
          return { sessionid: sessionData.sessionId};
      }, [sessionData.sessionId])
  const handleLogout = () => {
    clearError(logoutApiError)
    const headers = { sessionid: sessionData.sessionId };
    logout(headers, dispatch, (response) => {
      if (response.result === 'SUCCESS') {
        navigate('/login');
        dispatch(resetFilter());
        dispatch(resetReportFilter());
        dispatch(resetAlertPlatFormFilters());
        dispatch(resetUserFilters());
      } else {
        const error = response.error;        
        showToast(error.severity, error?.errorMsg || error?.summary, logoutApiError);
      }
    });
  };
  const command = (url, { originalEvent } = {}) => {
    if (originalEvent && (originalEvent.ctrlKey || originalEvent.metaKey)) {
      window.open(url, '_blank');
    } else {
      navigate(url);
    }
  }
  const allMenuItems = [
    {
      label: "Profile Details",
      icon: "pi pi-user",
      command: command.bind(null,'/profile-details'),
      isVisible: true
    },
    {
      label: "Logout",
      icon: "pi pi-power-off",
      isVisible: true,
      command: () => {
        setVisible(true);
      }
    }
  ];

  const menuItems = allMenuItems.filter(item => item.isVisible);

  
  const userMenuItems = [
    {
      label: "Alerts",
      icon: "pi pi-list",
      command: command.bind(null,'/home')
    },
    {
      label: "Alert Tags",
      icon: "pi pi-th-large",
      command: command.bind(null,'/tags')
    },
    {
      label: "Case Updates",
      icon: "pi pi-share-alt",
      command: command.bind(null,'/case-updates')
    },
    {
      label: "User Management",
      icon: "pi pi-users",
      command: command.bind(null,'/user-management')
    },
    {
      label: "Audit Log",
      icon: "pi pi-history",
      command: command.bind(null,'/audit-log')
    },
    {
      label: "Member Analytics",
      icon: "pi pi-chart-bar",
      command: command.bind(null,'/my-analytics')
    },
    {
      label: "External Links",
      icon: "pi pi-globe",
      command: command.bind(null,'/external-links')
    },
    {
      label: "News & Updates",
      icon: "pi pi-sync",
      command: ({ originalEvent } = {}) => {
        if (originalEvent && (originalEvent.ctrlKey || originalEvent.metaKey)) {
          window.open('/news', '_blank');
        } else {
          if (originalEvent) originalEvent.preventDefault();
          dispatch(newsActions.updateTab({ activeIndex: 0 }));
          navigate('/news');
        }
      }
    },
    {
      label: "Reports",
      icon: "pi pi-file",
      command: command.bind(null,'/reports')
    },
    {
      label: "Betting Data",
      icon: "pi pi-book",
      command: command.bind(null,'/betting-data')
    }
  ];
  
  useEffect(() => {
    if (role === 'analyst'  || role === 'regulator' || role === 'governingbody') {
      getUnreadCount(headers, dispatch, (response) => {
        if (response.result === "SUCCESS") {
          const result = response?.data
          dispatch(filterOptionsActions.setMessageCount(result?.totalUnreadConversations ?? 0))
        }
      })
    }
  }, [dispatch, headers, role, location.pathname]);

  const footerContent = (
      <div>
          <ErrorMessage id={logoutApiError} />
          <PR.Button label="Cancel" onClick={() => {clearError(logoutApiError); setVisible(false);}} outlined className="logout-btns" />
          <PR.Button label="Logout" onClick={() => handleLogout()} outlined autoFocus className={` ${(role === 'regulator' || role === 'governingbody') ? 'regulator' : (role === 'analyst') ? 'analyst' : '' } logout-btns click-btn`} />
      </div>
  );

  const gotoCreateAlert=()=>{
    navigate("/create-alert");
}

  const getBackUrl = () => {
    let backUrl = `/${menuLinking.backBtn}`;
    if (menuLinking.backBtn?.includes('alerts') && menuLinking.backPageParams?.tagId && menuLinking.backPageParams?.tagName) {
      backUrl += `?tagId=${menuLinking.backPageParams.tagId}&tagName=${menuLinking.backPageParams.tagName}`;
    }
    return backUrl;
  }

  const start = <Link to="/home"><PR.Image src={role === 'analyst' ? logoDark : logo} alt="IBIA Logo" className="logo-img" /></Link>;
  const startBack = <Link to={getBackUrl()} className="flex align-items-center back-btn"> <i className="pi pi-arrow-left" />Back to {menuLinking.backBtnLabel || menuLinking.backBtn}</Link>

  const end = <div className="flex align-items-center gap-4">
                <Link to="/help" className="right-icons"><i className="pi pi-question-circle"></i> {(role !== 'regulator' && role !== 'governingbody') && 'Help guide'}</Link>
                {  role === 'analyst' && (
                  <>
                  <PR.Button className="create-button" severity="primary" label="Create Alert" onClick={() => gotoCreateAlert()}/>
                  {role === 'analyst' && (
                  <Link to="/conversations" className="message-icon">
                    {store?.messageCount !== 0 && <PR.Badge value={store?.messageCount}></PR.Badge>}
                      <PR.Image src={chatIcon} alt="Messages" />
                    </Link> 
                  )}
                  <PR.Button
                      icon="pi pi-bars"
                      className="menu-bars-button"
                      onClick={(e) => userMenu.current.toggle(e)}
                  />
                </>
              )}
                <PR.Menu model={userMenuItems} popup popupAlignment="right" ref={userMenu} />
                <span className="line"></span>
                <span className="flex align-items-center profile-icon" onClick={(e) => menu.current.toggle(e)}>
                  <PR.Button icon={<ProfileImageDisplay profileImage={profileData?.profilePic} />} className="user-button" rounded outlined severity="secondary" aria-label="User" />
                  <PR.Button
                      icon="pi pi-chevron-down"
                      iconPos="right"
                      className="drop-down-button"
                  />
                 </span>
                <PR.Menu model={menuItems} popup ref={menu} />
              </div>;

  return (
    <>
      <section className="header-section sticky-header">
        <div className="w-12">
          <header className="grid grid-nogutter">
              <div className="w-12 flex align-items-center">
                <PR.Menubar start={menuLinking.backBtn ? startBack : start} end={end} className="w-12 top-header" />
              </div>
          </header>
        </div>
      </section>
      <PR.Dialog visible={visible} footer={footerContent} className="logout-dialog">
          <div className="logout-section">
              <h2>Logout</h2>
              <p>Are you sure you want to logout?</p>
          </div>
      </PR.Dialog>
    </>
  )
}

export default Header
